// import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { fetchProductsStartAsync } from "./reducers/productActions";
// import Navbar from "./components/NavbarOld";
// import Home from "./components/HomePage";
import Home from "./components/dashboard/Homepage";
import Cart from "./components/cart/Cart";
import Product from "./components/Product";
import "./App.css";
import SearchPage from "./components/SearchPage";
import Orders from "./components/Orders";
import TypeWise from "./components/TypeWise";
import SignUp from "./components/login/Signup";
import SignIn from "./components/login/SignIn";
import SignOut from "./components/login/SignOut";

// import { createMemoryHistory } from "history";
import CategoryWise from "./components/CategoryWise";
import PrivateRoute from "./components/PrivateRoute";
import ShippingAddress from "./components/ShippingAddress";
import PaymentPage from "./components/PaymentPage";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminCategories from "./components/admin/AdminCategories";
import AdminProducts from "./components/admin/AdminProducts";
import AdminOrder from "./components/admin/AdminOrder";

function App() {
  const { cartProducts, totalQuantities } = useSelector(
    (state) => state.cartReducer
  );

  const {products,isFetching} = useSelector((state)=>state.productReducer)

  useEffect(() => {
    // useDispatch({type:"FETCH_PRODUCTS_START"})
    fetchProductsStartAsync()
    localStorage.setItem("productsInCart", JSON.stringify(cartProducts));
  }, [cartProducts, totalQuantities]);

  // const history = createMemoryHistory();
  console.log('products', products);
    console.log('isProductsFetching', isFetching);

  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route index element={<Home />} />
            <Route path="/admin/dashboard" element={<AdminDashboard/>} />
            <Route path="/admin/categories" element={<AdminCategories/>} />
            <Route path="/admin/products" element={<AdminProducts/>} />
            <Route path="/admin/orders" element={<AdminOrder/>} />


            <Route
              path="cart"
              element={
                <PrivateRoute>
                  <Cart />
                </PrivateRoute>
              }
            />
            <Route path="search" element={<SearchPage />} />
            <Route path="shipping" element={<ShippingAddress />} />
            <Route path="payment" element={<PaymentPage />} />

            <Route path="signup" element={<SignUp />} />
            <Route path="signin" element={<SignIn />} />
            <Route path="signout" element={<SignOut />} />
            <Route
              path="products/category/:category"
              element={<CategoryWise />}
            />
            <Route path="product/:id" element={<Product />} />
            <Route path="products/type/:type" element={<TypeWise />} />
            <Route path="search" element={<SearchPage />} />
            <Route
              path="orders"
              element={
                <PrivateRoute>
                  <Orders />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
